import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { useContentReadMoreContext } from "~/components/content/content-read-more/contexts";
import type { contentReadMoreButtonContent$key } from "~/queries/__generated__/contentReadMoreButtonContent.graphql";

import { AppButton } from "./app-button";
import { Container, ReadFullArticleButton } from "./styles";

export type Props = {
  className?: string;
  reference: contentReadMoreButtonContent$key;
};

export const ContentReadMoreButton: FunctionComponent<Props> = ({ reference, ...attribs }) => {
  const content = useFragment(
    graphql`
      fragment contentReadMoreButtonContent on Content {
        ...appButtonContent
      }
    `,
    reference,
  );

  const { isClicked, setIsClicked } = useContentReadMoreContext();
  if (isClicked) return null;

  return (
    <Container {...attribs}>
      <ReadFullArticleButton noStyle onClick={() => setIsClicked?.(true)}>
        READ FULL ARTICLE
      </ReadFullArticleButton>
      <AppButton reference={content} />
    </Container>
  );
};

ContentReadMoreButton.displayName = "ContentReadMoreButton";
